import { render, staticRenderFns } from "./InstagramReel.vue?vue&type=template&id=4ed7fb83&scoped=true"
import script from "./InstagramReel.vue?vue&type=script&lang=js"
export * from "./InstagramReel.vue?vue&type=script&lang=js"
import style0 from "./InstagramReel.vue?vue&type=style&index=0&id=4ed7fb83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed7fb83",
  null
  
)

export default component.exports